import React, { useState } from "react";
import "./NewCommunication.scss";

import { Close, CommentOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../_services/accountServices";
import { API_COMMUNIQUE } from "../../apiCaller/communique.Caller";
import { requestType } from "../../types/GlobalType";
import ErrorBar from "../../component/errorComp/ErrorBar.tsx";
import ConnexionErrorDiv from "../../component/nodata/ConnexionErrorDiv.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  forceReload: () => void;
}
const NewCommunication = (props: Props) => {
  const [value, setvalue] = useState({
    objet: "",
    contenu: "",
    type_destinateur_id: "1",
  });

  const handleChange = (event) => {
    setvalue((prev) => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const navigate = useNavigate();

  const [stateDraft, setStateDraft] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleSubmitDraft = async () => {
    if (value.objet.trim().length < 1) {
      setStateDraft({
        ...stateDraft,
        errorMessage: "Veuillez entrer l'objet du communiqué",
      });
      return setTimeout(() => {
        setStateDraft((prev) => ({ ...prev, errorMessage: null }));
      }, 4000);
    }
    if (value.contenu.trim().length < 1) {
      setStateDraft({
        ...stateDraft,
        errorMessage: "Veuillez entrer le contenu du communiqué",
      });
      return setTimeout(() => {
        setStateDraft((prev) => ({ ...prev, errorMessage: null }));
      }, 4000);
    }
    setStateDraft({
      isLoading: true,
      errorMessage: null,
      successMessage: null,
    });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    let data = {
      objet: value.objet,
      contenu: value.contenu,
      type_destinateur_id: value.type_destinateur_id,
    };
    API_COMMUNIQUE.COMMUNIQUE.create(data, token)
      .then((response) => {
        console.log(response);
        setStateDraft({
          isLoading: false,
          errorMessage: null,
          successMessage: null,
        });

        toast.success("Communiqué enregistré entant que brouiullon", {
          duration: 4000,
        });
        props.setOpen(false);
        props.forceReload();
      })
      .catch((err) => {
        setStateDraft({
          isLoading: false,
          successMessage: false,
          errorMessage: false,
        });

        if (err.code === "ERR_NETWORK") {
          return setStateDraft({
            isLoading: false,
            successMessage: false,
            errorMessage: "ERR_NETWORK",
          });
        } else if (err.response.status === 403 || err.response.status === 401) {
          toast.error("Votre session a expiré, veuillez vous reconnectez");
          accountService.logout();
          navigate("/", { replace: true });
        } else {
          return toast.error(
            "Une erreur inconnue est survenue, réessayer plus tard" + err
          );
        }
      });
  };

  return (
    <>
      {stateDraft.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <div className="NewCommunication">
          <div className="dialog">
            <div className="headerUpdate">
              <div className="titleUpdate">
                <div className="left_">
                  <CommentOutlined className="ico" />
                  <span>Nouveau communiqué </span>
                </div>
                <div className="right_">
                  <Close className="ico" onClick={() => props.setOpen(false)} />
                </div>
              </div>
            </div>

            <div className="body">
              {stateDraft.errorMessage && (
                <ErrorBar title={stateDraft.errorMessage} />
              )}

              <div className="items_com">
                <h5>Destinateur</h5>
                <select
                  onChange={handleChange}
                  name="type_destinateur_id"
                  value={value.type_destinateur_id}
                >
                  <option value="1">PARENTS</option>
                  <option value="2">ENSEIGNANTS</option>
                  <option value="3">PARENTS & ENSEIGNANTS</option>
                </select>
              </div>
              <div className="items_com">
                <h5>Objet</h5>
                <input
                  type="text"
                  value={value.objet}
                  onChange={handleChange}
                  name="objet"
                  placeholder="Objet du comminiqué"
                />
              </div>
              <div className="items_com">
                <textarea
                  rows={8}
                  placeholder="communiqué..."
                  value={value.contenu}
                  onChange={handleChange}
                  name="contenu"
                />
              </div>
              <div className="btns">
                <button className="cancel" onClick={() => props.setOpen(false)}>
                  Annuler
                </button>
                <button className="send">Envoyer</button>
              </div>
            </div>
            <div className="brouillon">
              {stateDraft.isLoading ? (
                <>
                  <LoaderIcon /> loading...
                </>
              ) : (
                <>
                  <span onClick={handleSubmitDraft}>
                    Enregister en tant que brouillon
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewCommunication;
